import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag-horizontal",
  "use": "drag-horizontal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"drag-horizontal\"><path d=\"M18 8v3h-4v2h4v3l4-4zM6 16v-3h4v-2H6V8l-4 4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol